module.exports = __webpack_public_path__ + "static/img/ld.531dc6b5.png";